import { useEffect, useState } from 'react';
import { Flex, useBreakpointValue } from '@chakra-ui/react';

import DataTableSearch from './DataTableSearch';
import DataTableTable from './DataTableTable';
import DataTableCards from './DataTableCards';
import DataTablePaginate from './DataTablePaginate';

type VendaData = {
	agendamento: boolean;
	campanha: string;
	cupom: { id_desconto: string; type_desc: string; valor: string };
	distance: number;
	duration: number;
	endereco_entrega: EnderecoData;
	formatted_address: string;
	hora_agendada: string;
	cliente: {
		id: string;
		nome: string;
		doc: string;
		phone: string;
		cid: string;
	};
	id_order: number;
	items: ItemData[];
	merchant_id: number;
	mesa: boolean;
	mesa_number: string;
	mesa_token: string;
	order_data: string;
	order_status: string;
	pagamentos: PagamentoData[];
	prev_entrega: string;
	retirar: boolean;
	subTotal: number;
	taxa_entrega: number;
	taxa_service: number;
	tempo_preparo: number;
	tempo_preparo_str: string;
	total: number;
	totalFormatted: string;
	total_merchant: number;
}
type EnderecoData = {
	bai: string;
	cep: string;
	cid: string;
	cidcod: string;
	comp: string;
	distace: {
		distance: { value: number };
		duration: { value: number };
	};
	endereco: string;
	formatted_address: string;
	id: string;
	location: { lat: number; lng: number };
	num: string;
	ponto_ref: string;
	uf: string;
}
type PagamentoData = {
	band_pay: string;
	chave_pay: string;
	currency_pay: string;
	id_pay: number;
	method_pay: string;
	name_pay: string;
	tipchave_pay: string;
	trocoFormatted: string;
	troco_para: number;
	type_pay: string;
	url_pay: string;
}
type ItemData = {
	cod_barras: string;
	complementos: ComplementoData[];
	descricao: string;
	id: string;
	nome: string;
	obs: string;
	promocao: string;
	qtd: number;
	total: number;
	totalFormatted: string;
	url_imagem: string;
	valor: number;
	valorFormatted: string;
}
type ComplementoData = {
	codigo: string;
	descricao: string;
	grupo: string;
	nome: string;
	priceFormatted: string;
	qtd: number;
	qtd_gratis: number;
	qtd_maxima: number;
	valor: number;
}
interface DataTableVendasParams {
	data: VendaData[];
	setVendaModal: (venda: VendaData) => void;
	setModalVendaVisible: (visible: boolean) => void;
	setModalVendaCancelarVisible: (visible: boolean) => void;
}

const DataTableVendas: React.FC<DataTableVendasParams> = ({ 
	data,
	setVendaModal,
	setModalVendaVisible,
	setModalVendaCancelarVisible,
 }) => {
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const [loading, setLoading] = useState(true);

	const [pesqVendas, setPesqVendas] = useState<VendaData[]>(data);
	const [vendas, setVendas] = useState<VendaData[]>(data);

  const [sort, setSort] = useState({ por: '', cres: true });

  const [controls, setControls] = useState({
    page: 1,
    perPage: 10,
    totalPage: Math.ceil(data.length / 10),
  });

  useEffect(() => {
		setVendas(data.slice(0, 10));
    setLoading(false);
  }, []);

  async function handleUpdateList(
    page: number,
    perPage: number,
		vendas: VendaData[],
  ) {
    const auxPage = page - 1;
    const start = auxPage * perPage;
    const end = start + perPage;

		setVendas(vendas.slice(start, end));
  }

  return (
    <Flex w="100%" flexDir="column" my={6}>
      <DataTableSearch
        vendas={data}
        setPesqVendas={setPesqVendas}
        controls={controls}
        setControls={setControls}
        handleUpdateList={handleUpdateList}
      />

      {isWideVersion && (
        <DataTableTable
          vendas={vendas}
          pesqVendas={pesqVendas}
          sort={sort}
          setSort={setSort}
          controls={controls}
          handleUpdateList={handleUpdateList}
					setVendaModal={setVendaModal}
					setModalVendaVisible={setModalVendaVisible}
					setModalVendaCancelarVisible={setModalVendaCancelarVisible}
        />
      )}

      {!isWideVersion && !loading && (
				<DataTableCards
					vendas={vendas}
					pesqVendas={pesqVendas}
					sort={sort}
					setSort={setSort}
					controls={controls}
					handleUpdateList={handleUpdateList}
					setVendaModal={setVendaModal}
					setModalVendaVisible={setModalVendaVisible}
					setModalVendaCancelarVisible={setModalVendaCancelarVisible}
				/>
			)}

      <DataTablePaginate
				vendas_length={data.length}
				pesq_length={pesqVendas.length}
				pesqVendas={pesqVendas}
        controls={controls}
        setControls={setControls}
        handleUpdateList={handleUpdateList}
      />
    </Flex>
  );
};

export default DataTableVendas;
